import { Oval } from "react-loader-spinner";

export default function Loader({ loading }) {
  if (loading) {
    return (
      <>
        <div className="load">
          <Oval
          height={40}
          width={40}
          color="#0077ff"
          visible={true}
          ariaLabel="oval-loading"
          secondaryColor="#98c8ff "
          strokeWidth={5}
          />
        </div>
      </>
    );
  }

  return null;
}
